import React from 'react'
import './About.scss'

const About = () => {
  return (
    <div>About</div>
  )
}

export default About